import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
// material
import { Container, Card, Box, Stack, Button, Typography, Dialog, DialogContentText, DialogTitle, Divider, Paper, TextField, MenuItem } from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import { useDispatch } from '../../../../redux/store';
import useSettings from '../../../../hooks/useSettings';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import FileUpload from "react-mui-fileuploader";
import downloadFill from '@iconify/icons-eva/download-fill';
import { Icon } from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import apiContact from '../../../../api/contact';
import axios from 'axios';
import { useSnackbar } from 'notistack5';
import LinearProgress from '@mui/material/LinearProgress';
import { DialogAnimate } from '../../../../components/animate';
import Scrollbar from '../../../../components/Scrollbar';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import BackupIcon from '@mui/icons-material/Backup';
import test_dark from '../../../../components/test_dark.svg'
import UploadContact from '../ListSidebar/uploadContacrt';
import OptionImport from '../Form/optionImport';
import useAuth from '../../../../hooks/useAuth';

export default function DialogImportContact({ isOpenImportContact, setIsOpenImportContact,setIsRefreshContact }) {
    const inputRef = useRef(null);
    const { user } = useAuth();
    const { themeStretch } = useSettings();
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [filesToUpload, setFilesToUpload] = useState([]);
    const handleFilesChange = (files) => {
        // Update chosen files
        setFilesToUpload([...files]);
    };
    const [isSelectedType, setIsSelectedType] = useState(false);
    const [loading, setLoading] = useState(false);
    const [chooseType, setChooseType] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [departmentSelected, setDepartmentSelected] = useState(null);
    const [userSelected, setUserSelected] = useState(null);
    const [users, setUsers] = useState([]);
    const uploadFiles = async () => {
        // Create a form and post it to server
        let formData = new FormData();
        if (filesToUpload.length > 0) {
            try {
                filesToUpload.forEach((file) => formData.append("contact_import", file));
                const res_upload_contact = await apiContact.upload_contact(formData);
                enqueueSnackbar("Tạo thành công", { variant: 'success' });
                setFilesToUpload(null);
                inputRef.current.value = null;

            } catch (error) {
                console.log(error)
                const error_msg = JSON.parse(await error.response.data.text())

                enqueueSnackbar(error_msg.message[0], { variant: 'error' });
                console.error(error);
            }
        } else {
            enqueueSnackbar("Vui lòng chọn file thêm vào!!!", { variant: 'warning' });
        }
    };
    const dowloadTemplate = async () => {
        try {
            setLoading(true);


            const res_dowload_template = await apiContact.dowload_template_contact();
            console.log(res_dowload_template)
            const url = window.URL.createObjectURL(new Blob([res_dowload_template.data]));
            // tạo một thẻ a ẩn và kích hoạt sự kiện click để tải xuống tệp tin
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template_contact.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoading(false)
        } catch {
            setLoading(false)
        }


    }
    const handleChangeOptionImport = (e) => {
        setChooseType(e.target.value)
        if (e.target.value === "me") {
            setUserSelected(user.id);
            setIsSelectedType(true)
        }
        if (e.target.value === "custom") {
            setIsSelectedType(true)
        }

    }
    useEffect(() => {
        return () => {
            setIsSelectedType(false);
        }
    }, []);
    return (
        <DialogAnimate sx={{ maxHeight: 800 }} open={isOpenImportContact} onClose={() => setIsOpenImportContact(false)} fullWidth maxWidth="md">
            <DialogTitle>
                <Stack direction="row" justifyContent="flex-start" spacing={2} >
                    <TextFieldsIcon style={{ fontSize: '36px', marginTop: '10px', color: '#2978d5' }} ></TextFieldsIcon>
                    <Typography variant='h4' style={{ marginTop: '10px' }}> Tải lên danh bạ</Typography>
                </Stack>
            </DialogTitle>
            <Divider></Divider>
            <DialogContentText>
                <Scrollbar>
                    <Container maxWidth={themeStretch ? false : 'xl'}>
                        {isSelectedType ?
                            <UploadContact
                                chooseType={chooseType}
                                userSelected={userSelected}
                                departmentSelected={departmentSelected}
                                setIsOpenImportContact={setIsOpenImportContact}
                                setIsRefreshContact={setIsRefreshContact}
                            />
                            : <OptionImport
                                departmentSelected={departmentSelected}
                                setUserSelected={setUserSelected}
                                setDepartmentSelected={setDepartmentSelected}
                                setIsSelectedType={setIsSelectedType}
                                chooseType={chooseType}
                                handleChangeOptionImport={handleChangeOptionImport}
                            />}
                    </Container>
                </Scrollbar>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
                    <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)' }}> </Box>
                </Box>
            </DialogContentText>
        </DialogAnimate>
    );
}
